import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Servizi globali per l'applicazione.
 * Sono contenuti i servizi comuni tra i diversi moduli.
 */
@Injectable()
export class OicCoreService {
  // Gestione per il loading delle chiamate HTTP
  get isHttpRunning$(): Observable<boolean> {
    return this._isRunning$.asObservable();
  }

  private _isRunning$: Subject<boolean>;

  constructor() {
    this._isRunning$ = new Subject<boolean>();
  }

  startHttpRunning() {
    this._isRunning$.next(true);
  }

  stopHttpRunning() {
    this._isRunning$.next(false);
  }
}
